import { PatientListConfigurationFormComponentProps } from '@lmt/unicorn-shared/app/components/patients/list/common/types';
import { Field } from '@lmt/unicorn-shared/app/components/common/Field';
import { Input } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/Input';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';

import styles from './PatientListGeneralSettings.module.scss';
import {
  maxLengthRule,
  requiredRule,
} from '@lmt/unicorn-shared/app/helpers/form/react-hook-form-helper';

export const PatientListGeneralSettings: React.FC<
  PatientListConfigurationFormComponentProps & {
    isDisabled: boolean;
  }
> = (props) => {
  const i18nCalendar = useScopedTranslation(
    'patient_list_configuration.general',
  );
  const { register, control, watch, setValue, formState } = props.formMethods;

  return (
    <Field
      className={styles.field}
      title={i18nCalendar.t('fields.name')}
      required={true}
    >
      <div className={styles.input}>
        <Input
          {...register('name', { ...requiredRule(), ...maxLengthRule(100) })}
          errorText={formState.errors.name?.message}
          disabled={props.isDisabled}
        />
      </div>
    </Field>
  );
};
